

















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { UserModule, CanteenModule } from '../../store'
import html2canvas from 'html2canvas'
import DateUtil from '../../utils/toolsForDate'
import { findItemForTree } from '../../utils/toolsForCommon'
@Component({
  name: 'ReportForms',
  components: {
    'detail-account-table': () => import('../../components/detailAccountTable/index.vue'),
    'general-ledger-table': () => import('../../components/generalLedgerTable/index.vue'),
    'income-and-expenses-detail-table': () => import('../../components/incomeAndExpensesDetailTable/index.vue'),
    'property-liabilities-table': () => import('../../components/propertyLiabilitiesTable/index.vue'),
    'remaining-sum-table': () => import('../../components/remainingSumTable/index.vue')
  }
})
export default class ReportForms extends Vue {
  public paneName: string = 'detailAccountTableModule'
  public loadingForDetailAccountTableContainer: boolean = false
  public loadingForGeneralLedgerTableContainer: boolean = false
  public loadingForIncomeAndExpensesDetailTableContainer: boolean = false
  public loadingForPropertyLiabilitiesTableContainer: boolean = false
  public loadingForRemainingSumTableContainer: boolean = false
  // 头部相关：
  public monthForDate: string = ''
  public yearForDate: string = ''
  // public organizationChecked: string = ''
  // public organizationTreeData: Array<any> = []
  public subjectChecked: string | Array<string> = ''
  public subjectTreeData: Array<any> = []
  // 报表详情相关：
  public tableDetailForDetailAccountTableContainer: any = {}
  public tableDetailForGeneralLedgerTableContainer: any = {}
  public tableDetailForIncomeAndExpensesDetailTableContainer: any = {}
  public tableDetailForPropertyLiabilitiesTableContainer: any = {}
  public tableDetailForRemainingSumTableContainer: any = {}
  // print:
  public printForTableForDetailAccountTable: any = {
    id: 'detailAccountTable',
    popTitle: '', // 打印配置页上方标题
    extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
    preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
    previewBeforeOpenCallback () {
      // console.log('previewBeforeOpenCallback')
    }, // 预览窗口打开之前的callback（开启预览模式调用）
    previewOpenCallback () {
      // console.log('previewOpenCallback')
    }, // 预览窗口打开之后的callback（开启预览模式调用）
    beforeOpenCallback () {
      // console.log('beforeOpenCallback')
    }, // 开启打印前的回调事件
    openCallback () {
      // console.log('openCallback')
    }, // 调用打印之后的回调事件
    closeCallback () {
      // console.log('closeCallback')
    }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
    url: '',
    standard: '',
    extraCss: ''
  }
  public printForTableForGeneralLedgerTable: any = {
    id: 'generalLedgerTable',
    popTitle: '', // 打印配置页上方标题
    extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
    preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
    previewBeforeOpenCallback () {
      // console.log('previewBeforeOpenCallback')
    }, // 预览窗口打开之前的callback（开启预览模式调用）
    previewOpenCallback () {
      // console.log('previewOpenCallback')
    }, // 预览窗口打开之后的callback（开启预览模式调用）
    beforeOpenCallback () {
      // console.log('beforeOpenCallback')
    }, // 开启打印前的回调事件
    openCallback () {
      // console.log('openCallback')
    }, // 调用打印之后的回调事件
    closeCallback () {
      // console.log('closeCallback')
    }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
    url: '',
    standard: '',
    extraCss: ''
  }
  public printForTableForIncomeAndExpensesDetailTable: any = {
    id: 'incomeAndExpensesDetailTable',
    popTitle: '', // 打印配置页上方标题
    extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
    preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
    previewBeforeOpenCallback () {
      // console.log('previewBeforeOpenCallback')
    }, // 预览窗口打开之前的callback（开启预览模式调用）
    previewOpenCallback () {
      // console.log('previewOpenCallback')
    }, // 预览窗口打开之后的callback（开启预览模式调用）
    beforeOpenCallback () {
      // console.log('beforeOpenCallback')
    }, // 开启打印前的回调事件
    openCallback () {
      // console.log('openCallback')
    }, // 调用打印之后的回调事件
    closeCallback () {
      // console.log('closeCallback')
    }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
    url: '',
    standard: '',
    extraCss: ''
  }
  public printForTableForPropertyLiabilitiesTable: any = {
    id: 'propertyLiabilitiesTable',
    popTitle: '', // 打印配置页上方标题
    extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
    preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
    previewBeforeOpenCallback () {
      // console.log('previewBeforeOpenCallback')
    }, // 预览窗口打开之前的callback（开启预览模式调用）
    previewOpenCallback () {
      // console.log('previewOpenCallback')
    }, // 预览窗口打开之后的callback（开启预览模式调用）
    beforeOpenCallback () {
      // console.log('beforeOpenCallback')
    }, // 开启打印前的回调事件
    openCallback () {
      // console.log('openCallback')
    }, // 调用打印之后的回调事件
    closeCallback () {
      // console.log('closeCallback')
    }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
    url: '',
    standard: '',
    extraCss: ''
  }
  public printForTableForRemainingSumTable: any = {
    id: 'remainingSumTable',
    popTitle: '', // 打印配置页上方标题
    extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
    preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
    previewBeforeOpenCallback () {
      // console.log('previewBeforeOpenCallback')
    }, // 预览窗口打开之前的callback（开启预览模式调用）
    previewOpenCallback () {
      // console.log('previewOpenCallback')
    }, // 预览窗口打开之后的callback（开启预览模式调用）
    beforeOpenCallback () {
      // console.log('beforeOpenCallback')
    }, // 开启打印前的回调事件
    openCallback () {
      // console.log('openCallback')
    }, // 调用打印之后的回调事件
    closeCallback () {
      // console.log('closeCallback')
    }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
    url: '',
    standard: '',
    extraCss: ''
  }
  public reportFormSubjectAnalyzeDetail = {}
  // 针对学校基本信息：
  public schoolBaseInfo: any = {}

  // get treeDataForOrganatizion () {
  //   return CommonModule.treeDataForOrganatizion
  // }

  // get treeDataForSubOrganatizion () {
  //   return CommonModule.treeDataForSubOrganatizion
  // }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get batch (): string {
    let res = ''
    if (this.monthForDate) {
      res = this.monthForDate.split('-')[0] + this.monthForDate.split('-')[1]
    }
    return res
  }

  get tableNameText (): string {
    let tableNameText = ''
    switch (this.paneName) {
      case 'detailAccountTableModule':
        tableNameText = '《公安县中小学食堂明细账》'
        break
      case 'generalLedgerTableModule':
        tableNameText = '《公安县中小学食堂总账》'
        break
      case 'incomeAndExpensesDetailTableModule':
        tableNameText = '《公安县中小学食堂收支明细表》'
        // if (this.tableDetailForIncomeAndExpensesDetailTableContainer.school) {
        //   tableNameText = '《公安县中小学食堂收支明细表》（' + this.tableDetailForIncomeAndExpensesDetailTableContainer.school + '）'
        // }
        break
      case 'propertyLiabilitiesTableModule':
        tableNameText = '《公安县中小学食堂资产负债表》'
        break
      case 'remainingSumTableModule':
        tableNameText = '《公安县中小学食堂余额表》'
        break
    }
    return tableNameText
  }

  get tableId (): string {
    let tableId = ''
    switch (this.paneName) {
      case 'detailAccountTableModule':
        tableId = 'detailAccountTable'
        break
      case 'generalLedgerTableModule':
        tableId = 'generalLedgerTable'
        break
      case 'incomeAndExpensesDetailTableModule':
        tableId = 'incomeAndExpensesDetailTable'
        break
      case 'propertyLiabilitiesTableModule':
        tableId = 'propertyLiabilitiesTable'
        break
      case 'remainingSumTableModule':
        tableId = 'remainingSumTable'
        break
    }
    return tableId
  }

  async mounted () {
    this.getLastYear()
    this.getLastMonth()
    await Promise.all([
      // CommonModule.getTreeDataForOrganization(),
      // CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    this.initForTreeCheck()
    this.getReportFormLedgerDetail()
  }

  getLastYear () {
    let dateTime = new Date().getFullYear()
    dateTime = new Date(new Date().setFullYear(dateTime - 1)).getFullYear()
    this.yearForDate = dateTime + ''
  }

  getLastMonth () {
    this.monthForDate = DateUtil.getLastMonth()
  }

  initForTreeCheck () {
    // this.organizationTreeData = this.treeDataForSubOrganatizion
    this.subjectTreeData = this.treeDataForDisposeNameSubject
  }

  async getReportFormLedgerDetail () {
    try {
      const params = {
        school: this.userInfo.organizationId,
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          Object.assign(params, {
            subject: this.subjectChecked[this.subjectChecked.length - 1]
          })
        }
      }
      this.loadingForDetailAccountTableContainer = true
      const { data: result } = await (this as any).$http.reportFormLedgerDetail(params)
      this.loadingForDetailAccountTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForDetailAccountTableContainer = {}
        return this.$message.error(result.msg)
      }
      // 需要对数据进行处理：
      const list = (result.data || []).reduce((resultRes: any, current: any): Array<any> => {
        if (current.monthlyDetailLedgers) {
          current.monthlyDetailLedgers.forEach(item => {
            if (item.itemDetails) {
              item.itemDetails.forEach(v => {
                resultRes.push(v)
              })
            }
          })
        }
        return resultRes
      }, [])
      this.tableDetailForDetailAccountTableContainer = {
        list,
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          const subject = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', this.subjectChecked[this.subjectChecked.length - 1])
          Object.assign(this.tableDetailForDetailAccountTableContainer, {
            subject: subject && subject['name'] ? subject['name'] : '- -'
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  async getReportFormLedger () {
    try {
      const params = {
        school: this.userInfo.organizationId,
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          Object.assign(params, {
            subject: this.subjectChecked[this.subjectChecked.length - 1]
          })
        }
      }
      this.loadingForGeneralLedgerTableContainer = true
      const { data: result } = await (this as any).$http.reportFormLedger(params)
      this.loadingForGeneralLedgerTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForGeneralLedgerTableContainer = {}
        return this.$message.error(result.msg)
      }
      // 需要对数据进行处理：
      let list = (result.data || []).reduce((resultRes: any, current: any): Array<any> => {
        if (current.monthlyGenerateLedgers) {
          current.monthlyGenerateLedgers.forEach(item => {
            resultRes.push(item)
          })
        }
        return resultRes
      }, [])
      // 添加每个月的最后一天：
      list = list.map(item => {
        const timeArr = DateUtil.getEndDayOfDayThatMonth(item.year + '-' + item.month + '-01').split('-')
        item.day = timeArr[timeArr.length - 1]
        return item
      })
      this.tableDetailForGeneralLedgerTableContainer = {
        list,
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          const subject = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', this.subjectChecked[this.subjectChecked.length - 1])
          Object.assign(this.tableDetailForGeneralLedgerTableContainer, {
            subject: subject && subject['name'] ? subject['name'] : '- -'
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  async getReportFormIncomeAndOutputDetailQuery () {
    try {
      const params = {
        batch: this.batch,
        school: this.userInfo.organizationId
      }
      this.loadingForIncomeAndExpensesDetailTableContainer = true
      const { data: result } = await (this as any).$http.reportFormIncomeAndOutputDetailQuery(params)
      this.loadingForIncomeAndExpensesDetailTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForIncomeAndExpensesDetailTableContainer = {}
        return this.$message.error(result.msg)
      }
      // console.log(result, 'result')
      const resultRes = Object.keys(result.data || {}).reduce((resultRes: any, current: string): any => {
        if (['amortisedInstallation', 'foodIncome', 'foodOutput', 'otherIncome'].includes(current)) {
          result.data[current].forEach(v => {
            resultRes[v.subjectStr + 'thisPeriodAmount'] = v.thisPeriodAmount
            resultRes[v.subjectStr + 'thisYearCount'] = v.thisYearCount
            resultRes[v.subjectStr + 'subject'] = v.subject
          })
        }
        return resultRes
      }, {})
      const timeArr = DateUtil.getEndDayOfDayThatMonth(this.monthForDate + '-01').split(' ')[0].split('-')
      this.tableDetailForIncomeAndExpensesDetailTableContainer = {
        ...resultRes,
        ...(result.data || {}),
        timeArr
      }
      // console.log(this.tableDetailForIncomeAndExpensesDetailTableContainer, 'tableDetailForIncomeAndExpensesDetailTableContainer')
    } catch (err) {
      console.log(err)
    }
  }

  async getReportFormAssetsAndLiabilitiesQuery () {
    try {
      const params = {
        batch: this.batch,
        school: this.userInfo.organizationId
      }
      this.loadingForPropertyLiabilitiesTableContainer = true
      const { data: result } = await (this as any).$http.reportFormAssetsAndLiabilitiesQuery(params)
      this.loadingForPropertyLiabilitiesTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForPropertyLiabilitiesTableContainer = {}
        return this.$message.error(result.msg)
      }
      // test:
      // result.data = {
      //   assets: [
      //     {
      //       endThisPeriod: '100.00',
      //       initThisYear: '400.00',
      //       subjectStr: '现金'
      //     }
      //   ],
      //   income: [],
      //   liabilities: [],
      //   netAssets: [],
      //   output: [],
      //   school: '公安县第一中学',
      //   financePrincipal: '公安县第一中学',
      //   poster: '公安县第一中学'
      // }
      // console.log(result, 'result')
      const resultRes = Object.keys(result.data || {}).reduce((resultRes: any, current: string): any => {
        if (['assets', 'income', 'liabilities', 'netAssets', 'output'].includes(current)) {
          result.data[current].forEach(v => {
            resultRes[v.subjectStr + 'initThisYear'] = v.initThisYear
            resultRes[v.subjectStr + 'endThisPeriod'] = v.endThisPeriod
          })
        }
        return resultRes
      }, {})
      const timeArr = DateUtil.getEndDayOfDayThatMonth(this.monthForDate + '-01').split(' ')[0].split('-')
      this.tableDetailForPropertyLiabilitiesTableContainer = {
        ...resultRes,
        ...(result.data || {}),
        timeArr
      }
      // console.log(this.tableDetailForPropertyLiabilitiesTableContainer, 'tableDetailForPropertyLiabilitiesTableContainer')
    } catch (err) {
      console.log(err)
    }
  }

  async getReportFormSubjectBalanceQuery () {
    try {
      const params = {
        batch: this.batch,
        school: this.userInfo.organizationId
      }
      this.loadingForRemainingSumTableContainer = true
      const { data: result } = await (this as any).$http.reportFormSubjectBalanceQuery(params)
      this.loadingForRemainingSumTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForRemainingSumTableContainer = []
        return this.$message.error(result.msg)
      }
      const timeArr = DateUtil.getEndDayOfDayThatMonth(this.monthForDate + '-01').split(' ')[0].split('-')
      this.tableDetailForRemainingSumTableContainer = {
        ...(result.data || {}),
        timeArr
      }
      // console.log(this.tableDetailForRemainingSumTableContainer, 'tableDetailForRemainingSumTableContainer')
    } catch (err) {
      console.log(err)
    }
  }

  beforeLeave (activeName: string): void {
    switch (activeName) {
      case 'detailAccountTableModule':
        this.getReportFormLedgerDetail()
        break
      case 'generalLedgerTableModule':
        this.getReportFormLedger()
        break
      case 'incomeAndExpensesDetailTableModule':
        this.getReportFormIncomeAndOutputDetailQuery()
        this.getSchoolBaseInfo()
        break
      case 'propertyLiabilitiesTableModule':
        this.getReportFormAssetsAndLiabilitiesQuery()
        break
      case 'remainingSumTableModule':
        this.getReportFormSubjectBalanceQuery()
        break
    }
  }

  // 选择日期--月份：
  changeForMonthForDate (value): void {
    this.beforeLeave(this.paneName)
  }

  // 选择日期--年份：
  changeForYearForDate (value): void {
    this.beforeLeave(this.paneName)
  }

  downForTable (loadingForWho): void {
    this.$nextTick(async () => {
      this[loadingForWho] = true
      let _that: any = this
      let ele = document.querySelector('#' + this.tableId) as any
      let width = ele.offsetWidth
      let height = ele.offsetHeight
      let scale = 6
      const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft // 获取滚动轴滚动的长度
      const rect = ele.getBoundingClientRect() // 获取元素相对于视口的
      let canvas = await html2canvas(ele, {
        width,
        height,
        scale,
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true, // 允许跨域图片
        logging: false,
        x: rect.left, // 绘制的dom元素相对于视口的位置
        y: rect.top,
        scrollX: -scrollLeft, // 滚动的长度
        scrollY: 0
      })
      let imgUrl = canvas.toDataURL('image/png')
      // 下载：
      var eleLink = document.createElement('a')
      eleLink.href = imgUrl // 转换后的图片地址
      eleLink.download = this.tableNameText + '.png'
      document.body.appendChild(eleLink)
      eleLink.click()
      document.body.removeChild(eleLink)
      _that.$message.success('下载成功')
      this[loadingForWho] = false
    })
  }

  downForTableForDetailAccountTableContainer () {
    this.loadingForDetailAccountTableContainer = true
    const keysList = ['month', 'day', 'proofNum', 'summary', 'debit', 'credit', 'direction', 'balance']
    const dataRes = (this.tableDetailForDetailAccountTableContainer.list || []).map(v => {
      return keysList.map(vv => {
        let res = ''
        switch (vv) {
          default:
            res = v[vv]
        }
        return res
      })
    })
    import('../../plugins/xlsx/exportExcel').then(excel => {
      try {
        excel.export_json_to_excel({
          multiHeader: [
            ['科目名称：', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -']
          ],
          multiHeader2: [
            [this.tableDetailForDetailAccountTableContainer.year + '年', this.tableDetailForDetailAccountTableContainer.year + '年', '凭证号', '摘要', '借方', '贷方', '方向', '余额']
          ],
          header: ['月', '日', '凭证号', '摘要', '借方', '贷方', '方向', '余额'],
          autoWidth: true,
          data: dataRes,
          merges: ['B1:H1', 'A2:B2', 'C2:C3', 'D2:D3', 'E2:E3', 'F2:F3', 'G2:G3', 'H2:H3'],
          filename: this.tableNameText + '.xlsx'
        })
        this.$message.success('公安县中小学食堂明细账，导出成功')
      } catch (err) {
        console.log(err, 'err')
        this.$message.error('抱歉，导出失败')
      }
    })
    setTimeout(() => {
      this.loadingForDetailAccountTableContainer = false
    }, 300)
  }

  downForTableForGeneralLedgerTableContainer () {
    this.loadingForGeneralLedgerTableContainer = true
    const keysList = ['month', 'day', 'summary', 'debit', 'credit', 'direction', 'balance']
    const dataRes = (this.tableDetailForGeneralLedgerTableContainer.list || []).map(v => {
      return keysList.map(vv => {
        let res = ''
        switch (vv) {
          default:
            res = v[vv]
        }
        return res
      })
    })
    import('../../plugins/xlsx/exportExcel').then(excel => {
      try {
        excel.export_json_to_excel({
          multiHeader: [
            ['科目名称：', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -']
          ],
          multiHeader2: [
            [this.tableDetailForGeneralLedgerTableContainer.year + '年', this.tableDetailForGeneralLedgerTableContainer.year + '年', '摘要', '借方', '贷方', '方向', '余额']
          ],
          header: ['月', '日', '摘要', '借方', '贷方', '方向', '余额'],
          autoWidth: true,
          data: dataRes,
          merges: ['B1:G1', 'A2:B2', 'C2:C3', 'D2:D3', 'E2:E3', 'F2:F3', 'G2:G3'],
          filename: this.tableNameText + '.xlsx'
        })
        this.$message.success('公安县中小学食堂总账，导出成功')
      } catch (err) {
        console.log(err, 'err')
        this.$message.error('抱歉，导出失败')
      }
    })
    setTimeout(() => {
      this.loadingForGeneralLedgerTableContainer = false
    }, 300)
  }

  // cascaderChooseChangeForOrganizationTreeData () {
  //   console.log('cascaderChooseChangeForOrganizationTreeData')
  // }

  cascaderChooseChangeForSubjectTreeData () {
    this.beforeLeave(this.paneName)
  }

  // 获取支出占比、生均量、单价：
  async elPopoverSubjectShow (subjectCode) {
    // try {
    //   if (!subjectCode) {
    //     this.reportFormSubjectAnalyzeDetail = {}
    //     return
    //   }
    //   const params = {
    //     month: this.batch,
    //     school: this.userInfo.organizationId,
    //     subject: subjectCode
    //   }
    //   const { data: result } = await (this as any).$http.reportFormSubjectAnalyze(params)
    //   if (result.code !== 200) {
    //     this.reportFormSubjectAnalyzeDetail = {}
    //     return
    //   }
    //   this.reportFormSubjectAnalyzeDetail = result.data || {}
    // } catch (err) {
    //   console.log(err)
    // }
  }

  // 获取学校基本信息：
  async getSchoolBaseInfo () {
    try {
      const params = {
        orgId: this.userInfo.organizationId
      }
      const { data: result } = await (this as any).$http.portalGetCanteenInfo(params)
      if (result.code !== 200) {
        this.schoolBaseInfo = {}
        return
      }
      this.schoolBaseInfo = (result.data.records.length && result.data.records[0]) || {}
    } catch (err) {
      console.log(err)
    }
  }

}
